import React from 'react';
import { useUserData } from '../contexts/UserDataContext';
import LoadingScreen from './LoadingScreen';

const AppLoadingWrapper = ({ children }) => {
  const { loading } = useUserData();

  if (loading) {
    return <LoadingScreen />;
  }

  return <>{children}</>;
};

export default AppLoadingWrapper;
